export const SET_ACTIVE_WARNING_INDEX = 'revisions:SET_ACTIVE_WARNING_INDEX'
